import { InjectionToken } from '@angular/core';

export interface LayoutEnvironment {
  documentationRootUrl: string;
}

export const TWIST_LAYOUT_ENVIRONMENT = new InjectionToken<LayoutEnvironment>('TWIST_LAYOUT_ENVIRONMENT');
